export default [
    "HTT",

    "PFTT",
    "PFTT_7N6JS",
    "PFTT_8N7JS",

    "PFFTT",
    "PFPTTF",
    "PFPTTF_7N7JS",
    "PFPTTF_7N8JS",
    
    "PFTTF",
    "PFTTF_7N7JS",
    "PFTTF_7N8JS",

    "PFTTNL",
    "PFTTNL_7N7JS",
    "PFTTNL_7N8JS",
    "PFPTTNL",
    "PFPTTNL_7N7JS",
    "PFPTTNL_7N8JS",
];